import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import InventoryIcon from '@mui/icons-material/Inventory2';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import AssocDocumentDialog from '../Vehicle_Components/AssocDocumentDialog';
import EditVehicleDialog from '../Vehicle_Components/EditVehicleDialog';
import VehicleImageDialog from '../Vehicle_Components/VehicleImageDialog';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import { vehicleToString, notifySomething } from '../_Utils/AppDocuCommon';
import AssocPacketCalibrationDialog from '../Vehicle_Components/AssocPacketCalibrationDialog';
import { Dialog, DialogContent, DialogTitle, Box } from '@mui/material';
import { isQuillEmpty } from '../../../utils/quill';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    padding: 0,
  },
}));

class ActionsFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      dialogTitle: '',
      dialogContent: '',
    };
  }

  deleteVehicleService = async (vehicleId) => {
    if (!window.confirm('Delete this car?')) return;
    try {
      const res = await AppDocuServiceCall.deleteVehicle(vehicleId);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error deleting car', 'error');
        return;
      }
      await this.props.onItemsChange(); // Refresh the vehicles list after deletion !!!
    } catch (error) {
      console.error('Error deleting car:', error);
      notifySomething('Error deleting car', 'error');
    }
  };
  
  render() {
    const { dialogOpen } = this.state;
    const { row, onOpenAssocPacketCalibrationDialog, onOpenAssocDocumentDialog, onOpenEditVehicleDialog, onOpenVehicleImageDialog } = this.props;
    const hasUserNotes = !isQuillEmpty(row.user_notes);
    const hasInternalNotes = !isQuillEmpty(row.internal_notes);    
    const hasImage = row.has_image == 1;
    let iconColor = '#bbb';
    if (hasInternalNotes || hasUserNotes) iconColor = 'black'; // verde
    const iconDisabled = !hasUserNotes && !hasInternalNotes;
    return (
      <div style={{ display: 'flex', gap: 0, alignItems: 'center', minWidth: 90 }}>
        <Tooltip title="Edit">
          <IconButton size="small" onClick={() => onOpenEditVehicleDialog && onOpenEditVehicleDialog(row)}>
            <EditIcon style={{ color: '#111', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton size="small" onClick={() => this.deleteVehicleService(row.id)}>
            <DeleteIcon style={{ color: 'darkred', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
        
        <Tooltip title={iconDisabled ? 'No Notes' : 'View Notes'}>
          <span>
            <IconButton size="small" disabled={iconDisabled} onClick={() => !iconDisabled && this.setState({ dialogOpen: true })} style={{ padding: 4 }}>
              <StickyNote2Icon style={{ color: iconColor, fontSize: 20 }} />
            </IconButton>
          </span>
        </Tooltip>

        <HtmlTooltip 
          placement="bottom-start"
          title={
            hasImage ? (
              <Box sx={{ p: 0.5 }}>
                <img 
                  src={`https://api.serviceapplications.net/AppDocu/machine/getImage?id=${row.id}&t=${new Date().getTime()}`} 
                  alt="preview" 
                  style={{ width: '100%', display: 'block' }} 
                />
              </Box>
            ) : "No Image"
          }
        >
          <IconButton size="small" onClick={() => onOpenVehicleImageDialog && onOpenVehicleImageDialog(row)}>
            <ImageIcon style={{ color: hasImage ? 'black' : 'darkgray', fontSize: 20 }} />
          </IconButton>
        </HtmlTooltip>

        <Tooltip title="View Documents">
          <span>
            <IconButton size="small" onClick={() => onOpenAssocDocumentDialog && onOpenAssocDocumentDialog(row)}>
              <Badge 
                badgeContent={row.document_count > 0 ? row.document_count : null} 
                sx={{ '& .MuiBadge-badge': { backgroundColor: 'info.main', color: 'white', minWidth: 18, height: 18, fontSize: 12, right: 0, top: 2, zIndex: 2 } }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                overlap="rectangular"
              >
                <DescriptionIcon style={{ color: row.document_count > 0 ? 'black' : 'darkgray', fontSize: 20 }} />
              </Badge>
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="View Packets/Calibrations">
          <span>
            <IconButton size="small" onClick={() => onOpenAssocPacketCalibrationDialog && onOpenAssocPacketCalibrationDialog(row)}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'nowrap' }}>
                <Badge
                  badgeContent={row.package_count > 0 ? row.package_count : null}
                  sx={{ '& .MuiBadge-badge': { backgroundColor: 'orange', color: 'white', minWidth: 18, height: 18, fontSize: 12, right: 0, top: 2, zIndex: 2 } }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  overlap="rectangular"
                >
                  <Badge
                    badgeContent={row.calibration_count > 0 ? row.calibration_count : null}
                    sx={{ '& .MuiBadge-badge': { backgroundColor: 'green', color: 'white', minWidth: 18, height: 18, fontSize: 12, right: -16, top: 2, zIndex: 1 } }}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    overlap="rectangular"
                  >
                    <InventoryIcon style={{ color: (row.package_count > 0 || row.calibration_count > 0) ? 'black' : 'darkgray', fontSize: 20 }} />
                  </Badge>
                </Badge>
              </span>
            </IconButton>
          </span>
        </Tooltip>

        
            
                {/* Dialog per visualizzare le Notes */}
                <Dialog open={dialogOpen} onClose={() => this.setState({ dialogOpen: false })} maxWidth="md" fullWidth>
                  <DialogTitle>
                    Notes
                    {row && vehicleToString(row.id, row)}          
                  </DialogTitle>
                  <DialogContent>
                    <div style={{ marginBottom: 16, fontWeight: 'bold', color: '#1976d2' }}>User Notes</div>
                    <div style={{ minHeight: 40, marginBottom: 24 }}
                      dangerouslySetInnerHTML={{ __html: hasUserNotes ? row.user_notes : '<span style="color:#bbb">(none)</span>' }} />
                    <div style={{ marginBottom: 16, fontWeight: 'bold', color: '#43a047' }}>Internal Notes</div>
                    <div style={{ minHeight: 40 }}
                      dangerouslySetInnerHTML={{ __html: hasInternalNotes ? row.internal_notes : '<span style="color:#bbb">(none)</span>' }} />
                  </DialogContent>
                </Dialog>
                
      </div>
    );
  }
};

class ActionsTypeProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assocDocumentVehicleData: null, 
      assocPacketCalibrationVehicleData: null,
      vehicleDataToEdit: null,
      vehicleDataForImage: null,
    };
  }
  
  handleCloseAssocDocumentDialog = async () => {
    await this.setState({ assocDocumentVehicleData: null });
    await this.props.onItemsChange(); // Refresh the vehicles list after closing dialog
  }

  handleCloseAssocPacketCalibrationDialog = async () => {
    await this.setState({ assocPacketCalibrationVehicleData: null });
    await this.props.onItemsChange(); // Refresh the vehicles list after closing dialog
  }

  render() {
    const { for: forColumns, ...rest } = this.props;
    return (
      <>
        <DataTypeProvider
          formatterComponent={props => <ActionsFormatter 
              row={props.row} 
              onOpenAssocDocumentDialog={row => this.setState({ assocDocumentVehicleData: row })} 
              onOpenAssocPacketCalibrationDialog={row => this.setState({ assocPacketCalibrationVehicleData: row })} 
              onOpenEditVehicleDialog={row => this.setState({ vehicleDataToEdit: row })}              
              onOpenVehicleImageDialog={row => this.setState({ vehicleDataForImage: row })}
              onItemsChange={this.props.onItemsChange}
            />}
          for={forColumns}
          {...rest} />

        <AssocDocumentDialog
          vehicleData={this.state.assocDocumentVehicleData}
          onClose={() => this.handleCloseAssocDocumentDialog()} />

        <AssocPacketCalibrationDialog
          vehicleData={this.state.assocPacketCalibrationVehicleData}
          onClose={() => this.handleCloseAssocPacketCalibrationDialog()} />
          
        <EditVehicleDialog
          vehicleId={this.state.vehicleDataToEdit ? this.state.vehicleDataToEdit.id : null}
          onClose={() => this.setState({ vehicleDataToEdit: null })}
          onItemsChange={this.props.onItemsChange} />

        <VehicleImageDialog
          vehicleId={this.state.vehicleDataForImage ? this.state.vehicleDataForImage.id : null}
          onClose={() => this.setState({ vehicleDataForImage: null })}
          onItemsChange={this.props.onItemsChange} />
      </>
    );
  }
}

export default ActionsTypeProvider;
